import { type MCPServerInfo } from '../../types';

const FigmaDesktopServer: MCPServerInfo = {
  serverId: 'FIGMA_DESKTOP',
  name: 'Figma Desktop',
  slug: 'figma-desktop',
  description: 'Connect to the Figma desktop application on your machine.',
  source: {
    sourceType: 'LOCAL_URL',
    transport: 'STREAMABLE_HTTP',
    url: 'http://127.0.0.1:3845/mcp'
  },
  authenticationType: 'NONE',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {}
  }
};

export default FigmaDesktopServer;
